import React from "react";
import {Box, Text} from "grommet";
import NextAnchor from "./NextAnchor";

const PoweredByStreamlinedFooter = ({ children, align="center", showAllRightsReservedText, ...rest }) => (
    <Box>
        <Box align={align} margin={{ vertical: 'small' }}>
            <NextAnchor 
                button 
                label={(<Text size="small" color="text-weak">Powered by Streamlined</Text>)}
                plain
                onClick={() => {
                    if (typeof window !== "undefined") {
                        window.open("https://streamlinedpayments.com", '_blank');
                    }
                }} 
                hoverIndicator />
            {showAllRightsReservedText && (
                <Text size="small" color="text-weak" textAlign={align}>
                    &copy;
                    {`${new Date().getFullYear()} Streamlined Financial, Inc. All rights reserved.`}
                </Text>
            )}
        </Box>
    </Box>
);

export default PoweredByStreamlinedFooter;
